import { styled } from "@stitches/react";
import { useMonacoLibrary } from "features/monacoLibrary/Feature";
import { Box, Text } from "prism-react";
import React from "react";

import { DelayedLoading } from "components/DelayedLoading";

export const StyledMonaco = styled("div", {
  ".line-numbers": {
    fontSize: "$code",
    opacity: 0.7,
  },
  ".codicon-folding-expanded:before": {
    fontSize: "$code",
    opacity: 0.7,
    transition: "$opacity",
  },
  ".codicon-folding-collapsed:before": {
    fontSize: "$code",
    opacity: 0.7,
    transition: "$opacity",
  },
  ".monaco-editor .view-overlays .current-line": {
    borderRadius: "$2",
  },
  ".vs-dark .monaco-scrollable-element>.scrollbar>.slider": {
    width: "$1",
    borderRadius: "$2",
    background: "$support-system-scrollbar",
  },
  ".vs-dark .monaco-scrollable-element>.scrollbar>.slider:hover": {
    background: "$neutral-fg-base",
  },
  ".monaco-editor .squiggly-error": {
    background: "none",
    borderBottom: "2px solid $informative-error-base",
    boxSizing: "border-box",
  },
  ".monaco-editor .squiggly-warning": {
    background: "none",
    borderBottom: "2px solid $informative-warning-base",
    boxSizing: "border-box",
  },
  ".monaco-editor .squiggly-info": {
    background: "none",
    borderBottom: "2px solid $informative-info-base",
    boxSizing: "border-box",
  },
  ".monaco-editor .monaco-editor-overlaymessage": {
    boxShadow: "0px 2px 7px rgba(0, 0, 0, 0.15)",
  },
  ".monaco-editor .monaco-editor-overlaymessage .message": {
    background: "$neutral-bg-low",
    borderColor: "$neutral-bg-low",
    padding: "$1 $2",
    color: "$neutral-fg-high",
  },
  ".monaco-editor .monaco-editor-overlaymessage .anchor.top": {
    borderTopColor: "$neutral-bg-low",
  },
  ".monaco-editor .monaco-editor-overlaymessage .anchor.below": {
    borderTopColor: "$neutral-bg-low",
  },
  // We don't use hint at the moment
  // ".monaco-editor .squiggly-hint": {
  //   background: "none",
  //   borderBottom: "2px solid $informative-success-base",
  //   boxSizing: "border-box",
  // },
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const EditorLoader: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [monacoLibrary] = useMonacoLibrary();

  if (monacoLibrary.state === "READY") {
    return <StyledMonaco>{children}</StyledMonaco>;
  }

  return monacoLibrary.state === "ERROR" && monacoLibrary.error ? (
    <Text
      css={{
        color: "$neutral-bg-low",
        background: "$informative-error-base",
        padding: "$2 $3",
        display: "flex",
        height: "100%",
        borderRadius: "$1",
      }}
    >
      {monacoLibrary.error}
    </Text>
  ) : (
    <Box
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <DelayedLoading delay={1} size={10} />
    </Box>
  );
};
